<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div v-if="isInput" class="control">
      <input
        ref="input"
        v-model="computedValue"
        class="input is-small"
        :class="{ 'is-static': readOnly }"
        type="text"
        :size="size"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :disabled="disabled == 1"
        :readonly="readOnly == 1"
        autofocus=""
        @keydown="keydown"
      />
    </div>
    <div v-else class="control">
      <textarea
        ref="textarea"
        v-model="computedValue"
        class="textarea is-size-6-mobile is-size-5-tablet therapyinput"
        :class="{ 'is-static': readOnly }"
        type="text"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :disabled="disabled == 1"
        :readonly="readOnly == 1"
        autofocus=""
        @keydown="keydown"
      />
    </div>
  </div>
</template>
<script>
import { ref, computed, nextTick, watch } from 'vue';
export default {
  name: 'InputField',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    reset: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    isInput: {
      type: Boolean,
      default: true,
    },
    maxlength: {
      type: Number,
      default: 524288,
    },
    size: {
      type: Number,
      default: 10,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['inputupdate'],
  setup(props, { emit, expose }) {
    /*newValue is de middle-man,
    computedValue is de waarde waar het om draait
*/
    const newValue = ref('');
    const textarea = ref(null);
    const input = ref(null);
    const computedValue = computed({
      get: () => {
        return newValue.value;
      },
      set: (value) => {
        newValue.value = value;
        emit('inputupdate', newValue.value);
      },
    });

    const keydown = (event) => {
      emit('keydown', event);
    };

    const focus = () => {
      if (textarea.value) {
        textarea.value.focus();
      }
      if (input.value) {
        input.value.focus();
      }
    };

    const resize = async () => {
      if (props.isInput) {
        return;
      }

      if (textarea.value && textarea.value.style) {
        await nextTick();
        textarea.value.style.height = textarea.value.scrollHeight - 4 + 'px';
      }
    };
    watch(
      () => props.reset,
      async () => {
        newValue.value = '';
        await resize();
      },
      {
        immediate: true,
      }
    );

    const setValue = (val) => {
      newValue.value = val;
      emit('inputupdate', val);
      resize();
    };

    expose({ focus, setValue });

    return {
      computedValue,
      newValue,
      textarea,
      keydown,
    };
  },
};
</script>
<style lang="scss"></style>
